import Onboarding from "@/components/Onboarding";
import { Outlet } from "react-router-dom";
import { AdminProvider } from "./AdminContext";
import { AuthProvider } from "./AuthContext";
import { ToastProvider } from "./ToastContext";

export const AppProvider = () => {
    return (
        <ToastProvider>
            <AuthProvider>
                <AdminProvider>
                    <Outlet />
                    <Onboarding />
                </AdminProvider>
            </AuthProvider>
        </ToastProvider>
    )
}